export interface IParams {
  [key: string]: any;
}
export function combineParams(obj1: IParams, obj2: IParams): IParams {
  return { ...obj1, ...obj2 };
}

export function convertDateFieldsToISO(obj: IParams): IParams {
  const convertedObj: IParams = {};

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      if (obj[key] instanceof Date) {
        convertedObj[key] = obj[key].toISOString();
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        convertedObj[key] = convertDateFieldsToISO(obj[key]);
      } else {
        convertedObj[key] = obj[key];
      }
    }
  }
  return convertedObj;
}

export const mapToParams = (map: Map<string, string>): IParams => {
  const obj: IParams = {};
  map.forEach((value: string, key: string) => {
    obj[key] = value;
  });
  return obj;
};

export const paramsToMap = (params: IParams): Map<string, string> => {
  const map = new Map<string, string>();
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      map.set(key, params[key]);
    }
  }
  return map;
}
